export const settingsPanelStyles = {
    root: {
        //paddingLeft: 5,
        padding: 10,
        //margin: 10,
        height: 'auto',
        backgroundColor: '#F2F2F5',
        color: '#a0aabf',
        borderBottom: '1px solid #CDCED1',
    },
    input: {
        width: 58,
        height: 30,
        background: '#fff',
        borderColor: 'transparent',
        borderStyle: 'solid',
        borderWidth: '2px',
        borderRadius: '4px',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,.12)',
        display: 'inline',
        fontSize: '13px',
        lineHeight: '15px',
        outline: 0,
        padding: '3px 6px',
        boxSizing: 'border-box',
        textAlign: 'center',
    },
    flex: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: 2,
    },

    select: {
        margin: 3,
        width: 150,
        height: 28,
        borderRadius: 2,
        border: '1px solid #CDCED1',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,.12)',
        color: '#2F343E',
    },
    header: {
        color: '#000000',
        width: '67px',
        fontWeight: '500',
        fontSize: 12,
        '&:hover': {
            color: '#051931',
        },
    },
    sub_header: {
        color: '#2F343E',
        textAlign: 'center',
        textTransform: 'Uppercase',
        margin: 2,
        fontWeight: '400',
        fontSize: 12,
        '&:hover': {
            color: '#051931',
        },
    },
    icon: {
        color: '#2F343E',
        '&:hover': {
            color: '#051931',
        },
    },
    cell: {
        cellSpacing: -0,
    },
    td: {
        height: 30,
        textAlign: 'center',
    },
    tr: {
        height: 50,
        align: 'center',
    },
    panel: {
        marginBottom: '10px',
        marginTop: '10px',
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        flexWrap: 'nowrap',
        height: 30,
    },

    delete: {
        color: '#FFBF5B',
    },

    align_button: {
        width: 70,
        height: 30,
        borderRadius: 2,
        color: '#2F343E',
        cursor: 'pointer',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,.12)',
    },
    selectedItem: {
        width: 70,
        height: 30,
        borderRadius: 2,
        color: '#2F343E',
        cursor: 'pointer',
        border: '1px solid #DA4610',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,.12)',
    },
    button: {
        width: 'auto',
        height: 40,
        marginLeft: 20,
        borderRadius: 5,
        color: '#CDCED1',
        backgroundColor: '#2F343E',
        border: '1px solid #CDCED1',
    },
};

export const shelfComponentStyles = {
    root: ({ isDragging }: any) => ({
        opacity: isDragging ? 0.5 : 1,
        cursor: 'move',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '48px',
        flexDirection: 'row',
        boxSizing: 'border-box',
        color: '#CDCED1',
    }),

    drag: {
        marginLeft: 60,
    },

    section: {
        display: 'flex',
        alignItems: 'center',
        // border: '1px solid #ddd',
        margin: 10,
        padding: '5px 7spx',
        minHeight: '20px',
        backgroundColor: '#F2F2F5',
        '&:hover': {
            backgroundColor: 'white',
        },
        boxSizing: 'border-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        borderRadius: '4px',
        fontSize: '13px',
        lineHeight: '1.1',
        fontWeight: '400',
        color: '#38404a',
    },

    outer: {},
    label: {
        float: 'right',
        '&:hover': {
            color: '#051931',
        },
        color: 'black',
        fontSize: '13px',
        fontWeight: '500',
        lineHeight: '20px',
        //marginLeft:3,
        width: 125,
        display: 'inline-block',
    },
    icon: {
        padding: '10px',
        '&:hover': {
            fill: '#051931',
        },
    },
    image: {
        padding: '10px',
        marginLeft: '10px',
        '&:hover': {
            fill: '#051931',
        },
    },

    iconHover: {
        '&:hover .cls-1': {
            color: '5351D0',
        },
    },
};

export const settingsComponentStyles = {
    root: {
        paddingLeft: 10,
        marginBottom: 10,
        backgroundColor: '#F2F2F5',
        color: '#2F343E',
        borderBottom: '1px solid #CDCED1',
        display: 'flex',
        flexDirection: 'row',
    },
    src: {
        width: 203,
        height: 25,
        textAlign: 'left',
        borderRadius: 2,
        border: '1px solid #CDCED1',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,.12)',
        paddingLeft: 5,
    },
    socialsrc: {
        width: 200,
        height: 25,
        borderRadius: 2,
        // backgroundColor: '#2F343E',
        border: '1px solid #CDCED1',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,.12)',
        color: '#000000',
        paddingLeft: 10,
    },
    input: {
        width: 200,
        height: 25,
        textAlign: 'center',
        borderRadius: 5,
        color: '#A0AAA2',
        border: 'none',
    },
    header: {
        color: '#2F343E',
        marginBottom: '5px',
        fontSize: 12,
        '&:hover': {
            color: '#051931',
        },
    },
    width_height: {
        width: 70,
        height: 25,
        textAlign: 'center',
        borderRadius: 2,
        border: '1px solid #CDCED1',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,.12)',
        color: '#000000',
    },

    td: {
        height: 50,
        width: 50,
        align: 'center',
    },
    button: {
        width: 70,
        height: 30,
        marginLeft: 5,
        borderRadius: 5,
        color: '#CDCED1',
        backgroundColor: '#2F343E',
        border: '1px solid #CDCED1',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,.12)',
    },
};
